import { blacklistKey, getDb, type BlacklistRow } from './schema';

export async function listBlacklist(): Promise<BlacklistRow[]> {
  const db = await getDb();
  return db.getAll('blacklist');
}

export async function addBlacklist(tag: string, source: string | null = null): Promise<void> {
  const db = await getDb();
  await db.put('blacklist', {
    key: blacklistKey(source, tag),
    source,
    tag,
    addedAt: Date.now(),
  });
}

export async function removeBlacklist(tag: string, source: string | null = null): Promise<void> {
  const db = await getDb();
  await db.delete('blacklist', blacklistKey(source, tag));
}

/**
 * Returns the set of blacklisted tag strings applicable to a source: rows
 * with the matching source plus rows with `source = null` (applies to all).
 */
export async function getBlacklistedTagsForSource(source: string): Promise<Set<string>> {
  const all = await listBlacklist();
  const out = new Set<string>();
  for (const row of all) {
    if (row.source === null || row.source === source) {
      out.add(row.tag);
    }
  }
  return out;
}
